import {CoreGraphNodeId} from '../../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';
import {ref, Ref} from 'vue';
import {BaseNodeType} from '../../../../../@polygonjs/polygonjs/src/engine/nodes/_Base';
import {ModalStyle} from '../../../core/Modal';
import {EditorProps} from '../../../types';
import {CoreType} from '../../../../../@polygonjs/polygonjs/src/core/Type';
import {StoreController} from '../StoreController';

interface ParamModalData {
	nodeId: CoreGraphNodeId;
	style: ModalStyle;
}
interface ParamModalDataJSON {
	nodePath: string;
	style: ModalStyle;
}

function createDefaultStyle(): ModalStyle {
	const size = {x: 600, y: 400};
	const style: ModalStyle = {
		left: window.innerWidth * 0.5 - size.x * 0.5,
		top: 200,
		width: size.x,
		height: size.y,
	};
	return style;
}
// const DEBUG: ParamModalData = {
// 	nodeId: 276,
// 	style: createDefaultStyle(),
// };

export type ParamModalLayoutJSON = ParamModalDataJSON[];
export class EditorParamsModalsControllerClass {
	private static _instance: EditorParamsModalsControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorParamsModalsControllerClass());
	}

	private constructor() {}

	private _list: Ref<ParamModalData[]> = ref([]);
	// init() {
	// 	this._list
	// }

	// getters
	list(): ParamModalData[] {
		return this._list.value;
	}
	modalStyle(node: BaseNodeType) {
		const index = this._getIndex(node);
		if (index < 0) {
			return;
		}
		return this._list.value[index].style;
	}
	toJSON(): ParamModalLayoutJSON {
		const json: ParamModalLayoutJSON = [];
		for (let e of this._list.value) {
			const node = StoreController.engine.node(e.nodeId);
			if (node) {
				const elem = {
					nodePath: node.path(),
					style: {
						top: e.style.top,
						left: e.style.left,
						width: e.style.width,
						height: e.style.height,
					},
				};
				json.push(elem);
			}
		}
		return json;
	}
	fromJSON(json: ParamModalLayoutJSON) {
		if (!CoreType.isArray(json)) {
			return;
		}
		for (let element of json) {
			if (element.nodePath != null && element.style != null) {
				const node = StoreController.engine.scene.node(element.nodePath);
				if (node) {
					const style = element.style;
					if (style.top != null && style.left != null && style.width != null && style.height != null) {
						this._list.value.push({
							nodeId: node.graphNodeId(),
							style: {
								top: style.top,
								left: style.left,
								width: style.width,
								height: style.height,
							},
						});
					}
				}
			}
		}
	}
	setFromEditor(props: EditorProps) {
		const paramsModal = props.paramsModal;
		if (paramsModal == null) {
			return;
		}
		this.fromJSON(paramsModal);
	}

	// mutations
	add(node: BaseNodeType, style?: Partial<ModalStyle>): void {
		// we first need to to remove it, in case it is already present
		// as it would lead to duplicate modals
		this.remove(node);
		const newStyle = {
			...createDefaultStyle(),
			...style,
		};

		this._list.value.push({
			nodeId: node.graphNodeId(),
			style: newStyle,
		});
	}
	remove(node: BaseNodeType): ParamModalData | undefined {
		const index = this._getIndex(node);
		if (index < 0) {
			return;
		}
		const removedElements = this._list.value.splice(index, 1);
		return removedElements[0];
	}
	async updateStyle(node: BaseNodeType, newStyle: ModalStyle) {
		const index = this._getIndex(node);
		if (index < 0) {
			return;
		}
		const style = this._list.value[index].style;
		style.top = newStyle.top;
		style.left = newStyle.left;
		style.width = newStyle.width;
		style.height = newStyle.height;
	}
	private _getIndex(node: BaseNodeType) {
		return this._list.value.map((e) => e.nodeId).indexOf(node.graphNodeId());
	}

	moveToFront(node: BaseNodeType) {
		const removedElement = this.remove(node);
		if (removedElement) {
			this.add(node, removedElement.style);
		}
	}
}

export const EditorParamsModalsController = EditorParamsModalsControllerClass.instance();
